import { createContext } from "react";

const DocumentosContext = createContext();

export default DocumentosContext;
